"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = void 0;
function downloadFile(document, href, newTab) {
    var link = document.createElement('a');
    link.href = href;
    document.body.appendChild(link);
    if (newTab) {
        link.target = '_blank';
    }
    link.click();
    link.remove();
}
exports.downloadFile = downloadFile;
